import { render, staticRenderFns } from "./AttendCourtAppearanceInstructions.vue?vue&type=template&id=7477c5d2"
import script from "./AttendCourtAppearanceInstructions.vue?vue&type=script&lang=ts"
export * from "./AttendCourtAppearanceInstructions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports